module.exports = __webpack_public_path__ + "kudos_41.svg?64bf708f2c606f2879cea35a1c4d2504";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_41.svg
// module id = 141
// module chunks = 0